import { FunctionComponent } from 'react';
import Icon from '../../DataDisplay/Icon/Icon';
import styles from './TextFieldWrapper.module.scss';

export type TextFieldWrapperProps = {
  variant?: 'date' | 'website';
  isActive?: boolean;
  input?: React.JSX.Element;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

type FC = FunctionComponent<TextFieldWrapperProps>;

const TextFieldWrapper: FC = (props: TextFieldWrapperProps): React.JSX.Element => {
  const { variant = 'date', input, isActive, onFocus } = props;

  return (
    <div
      className={[styles.container, styles[variant], styles[getPositionClass()], styles[getActiveClass()]].join(' ')}
      onFocus={onFocus}
    >
      {variant === 'website' && (
        <div className={styles.websiteHeader}>
          <span>https://www.</span>
        </div>
      )}
      <div>{input}</div>
      {variant === 'date' && <Icon icon="calendar" width="15px" color="medium-dark" />}
    </div>
  );

  function getPositionClass() {
    return variant === 'date' ? 'space-between' : variant === 'website' ? 'flex-start' : '';
  }

  function getActiveClass() {
    return isActive ? 'active' : '';
  }
};

export default TextFieldWrapper;
